<template>
  <CountryPage country="uk" />
</template>